import { render, staticRenderFns } from "./EditHospital.vue?vue&type=template&id=727f3f38&scoped=true"
import script from "./EditHospital.vue?vue&type=script&lang=js"
export * from "./EditHospital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727f3f38",
  null
  
)

export default component.exports